import { Flex } from "components/Flex";
import { Text } from "components/Text";
import { format } from "date-fns";
import { useDateRangeSettings } from "hooks/useDateRangeSettings";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import styled from "styled-components";
import { AikaDate } from "utils/AikaDate";
export type DateSelectProps = {
  value: AikaDate;
  onChange: (val: AikaDate) => void;
};

const Container = styled.div`
  display: flex;
  height: 60px;
`;

const Button = styled.button`
  cursor: pointer;
  opacity: 0.5;
  transition: all 0.3s ease;
  background: none;
  border: 0;

  &:hover {
    color: ${(props) => props.theme.colors.primary};
    opacity: 1;
  }
`;

export function DateSelect({ value, onChange }: DateSelectProps) {
  const { current } = useDateRangeSettings();

  const shift = (delta: number) =>
    onChange(value.addDays(current.jumpCount * delta));

  const back = () => shift(-1);
  const forward = () => shift(1);

  const endDate = value.addDays(current.dayCount - 1);

  return (
    <Container>
      <Button onClick={back}>
        <FaChevronLeft />
      </Button>
      <Flex
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        flex="1"
      >
        <Text fontWeight={600} fontSize={2}>
          {current.dayCount === 1
            ? format(value.asLocalDate(), "dd MMM")
            : `${format(value.asLocalDate(), "dd MMM")} - ${format(
                endDate.asLocalDate(),
                "dd MMM"
              )}`}
        </Text>
        <Text fontSize={2}>{current.description}</Text>
      </Flex>
      <Button onClick={forward}>
        <FaChevronRight />
      </Button>
    </Container>
  );
}
